import { useMemo } from "react";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

/** Minimal `next/router`-style object for migrated VenueMonk / Next.js components. */
export function useNextStyleRouter() {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();

  const query = useMemo(() => {
    const q = {};
    searchParams.forEach((value, key) => {
      q[key] = value;
    });
    return q;
  }, [searchParams]);

  return {
    query,
    asPath: `${location.pathname}${location.search}`,
    pathname: location.pathname,
    push: (to) => navigate(to),
    replace: (to) => navigate(to, { replace: true }),
  };
}
